import ProyeccionCard from "./ProyeccionCard";
export default ProyeccionCard;